// Pure localStorage helpers for the auth session.
// Kept dependency-free so both api.js and auth.js can import it without a circular reference.
// Only the access token is persisted — the current account is derived from the loaded
// client profile (clientProfile.login), and the refresh token lives in an httpOnly cookie.

const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN'

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function setAccessToken(token) {
  if (token) localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export function clearSession() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

export function isAuth() {
  return !!getAccessToken()
}
